// src/components/Pages/Faq.jsx  →  /faq
import React from 'react';
import { Link } from 'react-router-dom';
import { FiHelpCircle, FiArrowLeft, FiArrowRight } from 'react-icons/fi';
import { useAuthGate } from '../../Context/AuthGateContext';
import './InfoPages.css';

const FAQS = [
  { q: '¿En qué fase está Bitplify?',
    a: 'Estamos en fase MVP (Beta). Ya funciona el mercado P2P entre comerciantes verificados, el portafolio y la gamificación, y hacemos recolección básica de datos. La verificación de identidad por niveles (KYC) y el escrow se activan por fases — podés ver el detalle en el Centro de seguridad.' },
  { q: '¿Qué es un mercado P2P y por qué importa?',
    a: 'Significa que operás persona a persona: vos y tu contraparte acuerdan el precio, no un exchange. Bitplify conecta a las partes y controla quién puede vender (solo comerciantes verificados), pero no custodia tus fondos.' },
  { q: '¿Cómo evitan que un estafador venda y desaparezca?',
    a: 'Hoy nadie puede vender sin ser un comerciante verificado por Bitplify. El acceso a vender se habilita por invitación, sobre una base de comerciantes aprobados con reputación y trazabilidad; el público general solo puede comprar. Así reducimos el riesgo de que un desconocido venda, cobre y se vaya. El escrow llegará en una fase posterior para reforzarlo.' },
  { q: '¿Tengo que verificar mi identidad?',
    a: 'Depende de lo que quieras hacer. Para explorar y armar tu portafolio no hace falta. Para comprar montos bajos pedimos datos básicos (Nivel 1). Para vender se requerirá verificación de identidad (Nivel 2), que estamos habilitando por fases.' },
  { q: '¿Qué datos recopilan hoy?',
    a: 'En esta fase MVP, lo básico del registro: email, usuario y teléfono. A medida que subís de nivel pediremos más datos, siempre el mínimo necesario y siempre cifrados.' },
  { q: '¿Es seguro operar acá?',
    a: 'Hoy la seguridad se apoya en que solo venden comerciantes verificados por invitación, más el cifrado SSL/TLS y la reputación pública de cada trader. Estamos sumando verificación de identidad (KYC) y escrow por fases. Aun así, operar con criptomonedas conlleva riesgo de mercado: nunca operes fondos que no puedas permitirte perder.' },
  { q: '¿Cómo me convierto en vendedor?',
    a: 'Hoy el rol de vendedor verificado se habilita con código de invitación. Cuando se active el KYC Nivel 2, vas a poder verificar tu identidad y vender sin invitación.' },
  { q: '¿Tiene algún costo?',
    a: 'Crear tu cuenta y explorar es gratis. Las condiciones de cada operación (spread, comisiones) las verás siempre antes de confirmar un trade.' },
];

export default function Faq() {
  const { openAuth } = useAuthGate();
  return (
    <div className="ip-wrap">
      <Link to="/" className="ip-back"><FiArrowLeft /> Volver al marketplace</Link>

      <div className="ip-hero">
        <span className="ip-eyebrow"><FiHelpCircle /> Preguntas frecuentes</span>
        <h1 className="ip-title">¿En qué te ayudamos?</h1>
        <p className="ip-sub">Lo esencial sobre cómo funciona Bitplify, la seguridad y la fase actual del proyecto.</p>
        <span className="ip-phase-badge"><span className="ip-live-dot" /> Versión MVP (Beta)</span>
      </div>

      <section className="ip-section">
        <div className="ip-faq">
          {FAQS.map((f, i) => (
            <details key={i} className="ip-faq-item">
              <summary className="ip-faq-q">{f.q}</summary>
              <p className="ip-faq-a">{f.a}</p>
            </details>
          ))}
        </div>
      </section>

      <div className="ip-cta">
        <h3>¿Listo para operar a tu precio?</h3>
        <p>Creá tu cuenta gratis y sumate al mercado P2P.</p>
        <button className="ip-cta-btn" onClick={() => openAuth('register')}>Crear mi cuenta <FiArrowRight /></button>
      </div>
    </div>
  );
}
